<template>
  <div id="nav" class="flex-col w-64 h-screen absolute md:relative overflow-auto" :class="{ 'hide-menu': hideMenu, 'vertical-navigation-mode-over': resize() }">
    <!--  -->
    <div v-if="user && user.type" class="nav-header flex items-center sticky top-0 justify-between">
      <router-link class="flex items-center no-active dashbord nav-logo" to="/">
        <img alt="RM Express" class="align-middle border-none img-cod" :src="image" />
      </router-link>
      <button v-if="resize()" @click="actionSidebar" class="nav-close focus:outline-none items-center flex">
        <i class="material-icons">close</i>
      </button>
    </div>
    <!--  -->

    <!--  -->
    <div class="h-full p-2 pt-4 bg-green-600  text-white" :class="$colors.sideBar">
      <!--  -->
      <!-- ===== SECTION: Général ===== -->
      <div class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('general')">
          <span class="nav-group-title">{{ $t('dashboard') }}</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('general')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('general')">
      <!-- Dashboard - uses team permission canViewDashboard for team members -->
      <menu-link v-if="getPermission('dashboard') && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType && user.accountType.includes('seller')))" to="/" :text="$t('dashboard')" class="link" icon="dashboard" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('warehouses') && getAccess('warehouses', 'update')" to="/warehouses" :text="$t('warehouses')" class="link" icon="business" hasSub="true" />
      <div v-if="['warehouses', 'newWarehouse'].indexOf($route.name) > -1 && getAccess('warehouses', 'create')">
         <menu-link to="/warehouses/new" v-if="getAccess('warehouses', 'create')" :text="$t('new_warehouse')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
        </div>
      </div>
      <!-- ===== SECTION: Catalogue ===== -->
      <div class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('catalogue')">
          <span class="nav-group-title">Catalogue</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('catalogue')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('catalogue')">
      <menu-link v-if="getPermission('products') && ((!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType.includes('seller'))) || ['TeleConsultant', 'StockManager', 'NRP', 'CancelledOrder', 'ToRemind'].indexOf(user.type) != -1)" to="/products" :text="$t('products')" class="link" icon="local_mall" hasSub="true" />
      <div v-if="['products', 'newProduct'].indexOf($route.name) > -1 && getAccess('products', 'create') && user.type !== 'GestionnaireCatalogue'">
        <menu-link v-if="getAccess('products', 'create')" to="/products/new" :text="$t('new_product')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('analytics') && ['Seller','Partner','Fournisseur','GestionnaireCatalogue'].indexOf(user.type) == -1" to="/callcenter" :text="$t('analytics')" class="link" icon="trending_up" />
      <!--  -->

      

      <!-- Hide Affiliates for team members -->
      <template v-if="!user.parentSeller && getPermission('affiliates') && user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur' && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType && (user.accountType.includes('affiliate') || user.accountType.includes('cpa'))))">

        <!--  -->
           <menu-link v-if="getPermission('affiliates')" to="#" text="Affiliates" name="affiliates"  :class="`link img ${$route.path?$route.path.replaceAll('/',''):''}`" img="https://img.icons8.com/pastel-glyph/64/FFFFFF/network-2-1--v1.png" imghover="https://img.icons8.com/pastel-glyph/64/network-2-1--v1.png" :isActive="isActive" @myFilter="myFilter('affiliates')" />
        <!--  -->

        <!--  -->
           <menu-link v-if="getPermission('dashboard') && getPermission('affiliates')" :to="'/affiliates/analytics?typeOrder='+(user.accountType && user.accountType.includes('cpa') && !user.accountType.includes('affiliate') ? 'cpa' : 'affiliate')" :text="$t('dashboard')" name="affiliates" class="link affil" children="true"  icon="dashboard" />
           <menu-link v-if="getPermission('affiliates')" to="/affiliates/offers" text="Offers" name="affiliates" class="link affil" children="true" img="https://img.icons8.com/dotty/80/FFFFFF/tags.png" imghover="https://img.icons8.com/dotty/80/tags.png" />
           <menu-link v-if="getPermission('affiliates')" to="/affiliates/requests" :text="'Request offres'" name="affiliates" class="link affil" children="true" :img="'https://img.icons8.com/puffy/64/FFFFFF/list.png'" :imghover="'https://img.icons8.com/puffy/64/list.png'" />
        <!--  -->
        <!--  -->
      </template>

         <!-- Hide marketplaces for team members -->
         <template v-if="!user.parentSeller && getPermission('marketplaces') && user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur' && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType && (user.accountType.includes('affiliate') || user.accountType.includes('cpa'))))">

          <!--  -->
            <menu-link v-if="getPermission('marketplaces')" to="#" text="Marketplaces" name="marketplaces"  :class="`link img ${$route.path?$route.path.replaceAll('/',''):''}`" img="https://img.icons8.com/wired/64/FFFFFF/marketplace-hub.png" imghover="https://img.icons8.com/wired/64/marketplace-hub.png" :isActive="isActive" @myFilter="myFilter('marketplaces')" />
          <!--  -->

          <!--  -->
            <menu-link v-if="getPermission('marketplaces')" to="/marketplaces/demands" :text="$t('Mettre en ligne')" name="marketplaces" class="link market" children="true"  img="https://img.icons8.com/ios/50/FFFFFF/put-in-motion.png" imghover="https://img.icons8.com/ios/50/put-in-motion.png" />
            <menu-link v-if="getPermission('marketplaces')" to="/marketplaces/products" text="Produits" name="marketplaces" class="link market" children="true" img="https://img.icons8.com/dotty/80/FFFFFF/tags.png" imghover="https://img.icons8.com/dotty/80/tags.png" />
            <menu-link v-if="getPermission('marketplaces')" to="/marketplaces/requests" :text="'Demande de produits'" name="marketplaces" class="link market" children="true" :img="'https://img.icons8.com/puffy/64/FFFFFF/list.png'" :imghover="'https://img.icons8.com/puffy/64/list.png'" />
          <!--  -->
          <!--  -->
          </template>



      <!--  -->
        </div>
      </div>
      <!-- ===== SECTION: Commandes ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('commandes')">
          <span class="nav-group-title">{{ $t('orders') }}</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('commandes')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('commandes')">
      <menu-link v-if="getPermission('orders')" to="/orders" :text="$t('orders')" class="link" icon="local_grocery_store" hasSub="true" />
      <div v-if="['orders', 'newOrder'].indexOf($route.name) > -1 && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType.includes('seller')))">
        <menu-link to="/orders/new" v-if="getAccess('orders', 'create') && ['NRP', 'CancelledOrder', 'ToRemind', 'TeleConsultant'].indexOf(user.type) == -1" :text="$t('new_order')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="user.type == 'TeleConsultant' || user.type == 'NRP' || user.type == 'CancelledOrder' || user.type == 'ToRemind'" to="/orders/confirmation" :text="$t('confirmation')" icon="add" />

      <div v-if="['orders', 'importOrders'].indexOf($route.name) > -1 && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType.includes('seller')))">
        <menu-link to="/orders/import" v-if="getAccess('orders', 'create') && ['NRP', 'CancelledOrder', 'ToRemind', 'TeleConsultant'].indexOf(user.type) == -1" :text="$t('import_orders')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <!-- Expeditions - uses team permission canViewExpeditions for team members -->
      <menu-link v-if="getPermission('expeditions') && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType && user.accountType.includes('seller')))" to="/expeditions" :text="$t('expeditions')" class="link" icon="local_airport" hasSub="true" />
      <div v-if="['expeditions', 'newExpedition'].indexOf($route.name) > -1">
        <menu-link to="/expeditions/new" v-if="getAccess('expeditions', 'create')" :text="$t('new_expedition')" icon="add" submenu="true" />
      </div>
      <!--  -->

    

      <!--  -->
        </div>
      </div>
      <!-- ===== SECTION: Administration ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('admin')">
          <span class="nav-group-title">Administration</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('admin')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('admin')">
      <menu-link v-if="getPermission('status') && getAccess('status', 'create')" to="/status" :text="$t('status')"  class="link" icon="sync" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('users') && getAccess('users', 'create')" to="/users" :text="$t('users')" class="link" icon="account_circle" hasSub="true" />
      <!--  -->

      <!--  -->
      <div v-if="['users', 'newUser'].indexOf($route.name) > -1">
        <menu-link to="/users/new" v-if="getAccess('users', 'create')" text="New user " icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <div v-if="['users', 'historyUser'].indexOf($route.name) > -1 && getPermission('userHistories')">
        <menu-link to="/users/history" v-if="getAccess('userHistories', 'create')" text="History" icon="history" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('partners') && ['Admin', 'CEO', 'Administrateur'].includes(user.type)" to="/partners" text="Partenaires" class="link" icon="person" hasSub="true" />
      <div v-if="['partners', 'newPartner'].indexOf($route.name) > -1">
        <menu-link to="/partners/new" v-if="getAccess('partners', 'create')" text="Nouveau partenaire" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('roles')" to="/roles" :text="$t('roles')" class="link" icon="lock" hasSub="true" />
      <div v-if="['roles', 'newRole'].indexOf($route.name) > -1">
        <menu-link to="/roles/new" v-if="getAccess('roles', 'create')" :text="$t('new_role')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('teams')" to="/teams" :text="$t('teams')" class="link" icon="group" hasSub="true" />
      <div v-if="['teams', 'newTeam'].indexOf($route.name) > -1">
        <menu-link to="/teams/new" v-if="getAccess('teams', 'create')" :text="$t('new_team')" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('subscribers')" to="/subscribers" :text="$t('subscribers')" class="link" icon="supervisor_account" hasSub="true" />
      <div v-if="['subscribers', 'newSubscribers'].indexOf($route.name) > -1">
        <menu-link to="/subscribers/new" v-if="getAccess('subscribers', 'create')" :text="$t('new_subscriber')" icon="add" submenu="true" />
        
      </div>
      <!--  -->

      <!--  -->
        </div>
      </div>
      <!-- ===== SECTION: Livraison & Paiements ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('livraison')">
          <span class="nav-group-title">Livraison &amp; Paiements</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('livraison')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('livraison')">
      <menu-link v-if="((getPermission('zones') && getAccess('zones', 'create')) || (getPermission('shippings') && getAccess('shippings', 'create'))) || (user.type == 'Accountant' || user.type == 'Return' || (['Seller','Partner'].includes(user.type) && getAccess('shippings', 'read')))" to="#" :text="$t('shipping_order')" name="shippings" class="link" icon="local_shipping" :isActive="isActive" @myFilter="myFilter('shippings')" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('zones') && getAccess('zones', 'create')" to="/zones" :text="$t('zones')" class="link" icon="map" name="shippings" children="true" />
      <div v-if="['zones', 'newZones'].indexOf($route.name) > -1">
        <menu-link to="/zones/new" v-if="getAccess('zones', 'create')" :text="$t('new_zone')" icon="add" class="child" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('shippings') && getAccess('shippings', 'create') || (user.type == 'Return' || (['Seller','Partner'].includes(user.type) && getAccess('shippings', 'read')))" to="/shippings" :text="$t('shippings')" class="link" icon="map" name="shippings" children="true" />
      <!--  -->

      <!--  -->
      <!-- Payments - uses team permission canViewPayments for team members -->
      <menu-link v-if="user.type === 'Fournisseur'" to="/ma-balance" text="Ma balance" class="link" icon="account_balance_wallet" />
      <menu-link v-else-if="getPermission('payments') || getPermission('charges') || getPermission('credits') || getAccess('balancesHistories', 'update')" :to="getPermission('payments')?'/payments':getPermission('charges')?'/charges':getPermission('credits')?'/credits':'/balances/requests'" :text="$t('payments')" name="paymentss"  :class="`link img ${$route.path?$route.path.replaceAll('/',''):''}`"  icon="card_giftcard"  :isActive="isActive" @myFilter="myFilter('paymentss')" hasSub="true" />
      <menu-link v-if="getPermission('payments') && user.type !== 'Fournisseur'" to="/payments" :text="$t('payments')" class="link" icon="payment" children="true" name="paymentss"/>
      <menu-link v-if="!user.parentSeller && !['Seller','Partner','Fournisseur'].includes(user.type) && getPermission('charges')" to="/charges" text="Charges" class="link" icon="card_giftcard"  name="paymentss" children="true" />
      <menu-link v-if="!['Seller','Partner','Fournisseur'].includes(user.type) && getAccess('balancesHistories', 'update')" to="/balances/requests" text="Retraits vendeurs" class="link" icon="exit_to_app"  name="paymentss" children="true" />
      <menu-link v-if="!['Seller','Partner','Fournisseur'].includes(user.type) && getAccess('balances', 'read')" to="/wallets" text="Portefeuilles vendeurs" class="link" icon="account_balance_wallet"  name="paymentss" children="true" />

      <!-- Sourcings - uses team permission canViewSourcings for team members -->
        </div>
      </div>
      <!-- ===== SECTION: Sourcing & Intégrations ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('sourcing')">
          <span class="nav-group-title">Sourcing &amp; Intégrations</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('sourcing')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('sourcing')">
      <menu-link v-if="getPermission('sourcings') && (!['Seller','Partner'].includes(user.type) || (['Seller','Partner'].includes(user.type) && user.accountType && user.accountType.includes('seller')))" to="/sourcings" text="Sourcings" class="link" icon="train" hasSub="true" />
      <div v-if="['sourcings', 'newSourcing'].indexOf($route.name) > -1">
        <menu-link to="/sourcings/new" v-if="getAccess('sourcings', 'create')" text="New sourcing" icon="add" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <!-- My Team - uses team permission canManageTeam for team members -->
      <menu-link v-if="getPermission('sellerTeam') && ['Seller','Partner'].includes(user.type)" to="/seller-team" :text="$t('my_team') || 'My Team'" icon="group_add" class="link" />
      <!--  -->

      <!--  -->
      <!-- Integrations (e-commerce platforms) - sellers/partners only -->
      <menu-link v-if="['Seller','Partner'].includes(user.type) && (!user.accountType || user.accountType.includes('seller'))" to="#" text="Integrations" name="integrations" class="link" icon="extension" :isActive="isActive" @myFilter="myFilter('integrations')" />
      <div v-if="['Seller','Partner'].includes(user.type) && (!user.accountType || user.accountType.includes('seller'))" class="youcan-wrap">
        <menu-link to="/integrations/youcan" text="YouCan" class="link" icon="local_grocery_store" name="integrations" children="true" />
        <span v-if="youcanConnected" class="youcan-dot" title="Connected"></span>
      </div>
      <!--  -->

      <!-- Programme de parrainage — Seller/Partner (leur code + gifts) & Admin (gestion) -->
      <menu-link v-if="!user.parentSeller && ['Seller','Partner','Admin','CEO','Administrateur'].includes(user.type)" to="/affiliations" text="Parrainage" class="link" icon="redeem" />
      <!--  -->


      <!--  -->
      <!-- Agent Dashboard - For ShippingAgent, NRP, Return, CancelledOrder, ToRemind with permission -->
        </div>
      </div>
      <!-- ===== SECTION: Opérations & Support ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue' && user.type !== 'Fournisseur'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('operations')">
          <span class="nav-group-title">Opérations &amp; Support</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('operations')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('operations')">
      <menu-link v-if="getPermission('agentDashboard') && ['ShippingAgent', 'NRP', 'Return', 'CancelledOrder', 'ToRemind'].includes(user.type)" to="/agent-dashboard" text="Agent Dashboard" class="link" icon="track_changes" />
      <!--  -->

      <!--  -->
      <!-- Stockist Dashboard - For StockManager with permission -->
      <menu-link v-if="getPermission('stockistDashboard') && ['StockManager', 'OperationsManager', 'Admin', 'CEO', 'Administrateur'].includes(user.type)" to="/stockist-dashboard" :text="$t('Gestion Stock')" class="link" icon="store" hasSub="true" />
      <div v-if="['stockistDashboard', 'stockistAssign', 'stockistReturns', 'stockistStats', 'stockistCouriers'].indexOf($route.name) > -1 && getPermission('stockistDashboard')">
        <menu-link to="/stockist-dashboard" :text="$t('Mon tableau de bord')" icon="dashboard" submenu="true" />
        <menu-link to="/stockist-dashboard/assign" :text="$t('Affecter des colis')" icon="local_shipping" submenu="true" />
        <menu-link to="/stockist-dashboard/returns" :text="$t('Confirmer des retours')" icon="replay" submenu="true" />
        <menu-link to="/stockist-dashboard/stats" :text="$t('Mes statistiques')" icon="trending_up" submenu="true" />
        <menu-link to="/stockist-dashboard/couriers" :text="$t('Mes livreurs')" icon="people" submenu="true" />
      </div>
      <!--  -->

      <!--  -->
      <!-- Agent Assignments - For ShippingManager, Admin, CEO with permission -->
      <menu-link v-if="getPermission('agentAssignments') && ['ShippingManager', 'Admin', 'CEO', 'Administrateur', 'OperationsManager'].includes(user.type)" to="/agent-assignments" text="Agent Assignments" class="link" icon="assignment_ind" />
      <!--  -->

      <!--  -->
      <!-- Account Manager Section - uses conversations and messages permissions -->
      <menu-link v-if="user.type === 'AccountManager' || (getPermission('agentDashboard') && getPermission('conversations'))" to="/account-manager" text="Dashboard Manager" class="link" icon="dashboard" />
      <menu-link v-if="user.type === 'AccountManager' || (getPermission('conversations') && getAccess('users', 'read'))" to="/account-manager/sellers" text="Mes vendeurs" class="link" icon="people" />
      <menu-link v-if="user.type === 'AccountManager' || (getPermission('messages') && getPermission('conversations'))" to="/account-manager/chat" text="Messages" class="link" icon="chat" />
      <!--  -->

      <!--  -->
      <!-- Chat Alerts - For CEO only -->
      <menu-link v-if="user.type === 'CEO'" to="/account-manager/alerts" text="Alertes messages" class="link" icon="warning" />
      <!--  -->

      <!--  -->
      <!-- Account Managers Management - For Admin/CEO only -->
      <menu-link v-if="['Admin', 'CEO', 'Administrateur'].includes(user.type)" to="/admin/account-managers" text="Account Managers" class="link" icon="supervisor_account" />
      <!--  -->

      <!--  -->
      <!-- Chat for Sellers -->
      <menu-link v-if="['Seller', 'Partner'].includes(user.type) && user.accountManager" to="/chat" text="Mon Account Manager" class="link" icon="headset_mic" />
      <!--  -->

      <!--  -->
      <!-- Settings - uses team permission canViewSettings for team members -->
      <!-- For team members: show if canViewSettings is true. For main users: check update access -->
        </div>
      </div>
      <!-- ===== SECTION: Système ===== -->
      <div v-if="user.type !== 'GestionnaireCatalogue'" class="nav-group js-nav-section">
        <button type="button" class="nav-group-head" @click="toggleSection('systeme')">
          <span class="nav-group-title">Système</span>
          <i class="material-icons nav-group-arrow" :class="{'is-open': isOpen('systeme')}">keyboard_arrow_down</i>
        </button>
        <div class="nav-group-body" v-show="isOpen('systeme')">
      <menu-link v-if="getPermission('settings') && (user.parentSeller || getAccess('settings', 'update'))" to="/settings" :text="$t('settings')" class="link" icon="settings" />
      <!--  -->

      <!--  -->
      <!-- Create Store - only for main sellers, not team members -->
      <menu-link v-if="!user.parentSeller && user.accountType && user.accountType.includes('seller')" to="https://storeino.com" isLinkHref="exist" text="Create Store" class="link img" img="https://storeno.b-cdn.net/shipsen/10-2021/1633356154211.png" imghover="https://storeno.b-cdn.net/shipsen/10-2021/1633356552917.png" target="_blank" />
      <!--  -->
      <!-- SMS sender - only for main sellers -->
      <menu-link
        v-if="!user.parentSeller && getPermission('senders') && getAccess('senders', 'create')"
        to="/senders"
        text="SMS sender"
        class="link img"
        img="https://img.icons8.com/sf-regular/48/ffffff/sms.png"
        imghover="https://img.icons8.com/sf-regular/48/000000/sms.png"
      />
      <!--  -->
      <!-- API - uses team permission canViewApi for team members -->
      <menu-link to="/orders/api" v-if="hasApiAccess()" :text="$t('API')" icon="device_hub" class="link" />
      <!--  -->
        </div>
      </div>
      <!-- ===== /sections ===== -->
    </div>
    <!--  -->
  </div>
</template>


<script>

export default {
  props: {
    user: { type: Object },
  },
  data() {
    return {
      login: false,
      token: null,
      isActive: { name: "", check: false },
      status: false,
      hideMenu: false,
      image: "https://storeno.b-cdn.net/rmexpressglob-v1/12-2024/1733757434470.jpeg",
      youcanConnected: false,
      openSections: {},   // état ouvert/fermé dyal chaque section (default = ouvert)
    };
  },
  async mounted() {
    this.token = this.$jwtService.getToken();
    if(this.user.accountType && this.user.accountType.length === 1 && (this.user.accountType[0] === 'affiliate' || this.user.accountType[0] === 'cpa')) this.image="https://storeno.b-cdn.net/rmexpressglob-v1/12-2024/1733758489909.jpeg";

    if (this.user) this.getAccess("users", "read");
    console.log('this.$store.getters.ShowSidebar;------', this.$store.getters.ShowSidebar)

    this.fetchYoucanStatus();
    this.$nextTick(this.refreshNavSections);
  },
  updated() {
    // les sections li kaع l-items dyalهom mخبيين b'permission => nخبيoها (l-DOM howa l-mرجع)
    this.refreshNavSections();
  },
  watch: {
    '$store.state.open': async function (oldVal, newVal) {
      this.hideMenu = oldVal;
    },
  },
  methods: {
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    actionSidebar() {
      this.$store.dispatch('actionSidebar');
    },
    resize() {
      return this.$store.getters.resize;
    },
    myFilter: function (name) {
      this.isActive.name = name;
      this.isActive.check = !this.isActive.check;
    },
    // ===== Sections (accordion) =====
    isOpen(key) {
      return this.openSections[key] !== false; // default: ouvert
    },
    toggleSection(key) {
      this.$set(this.openSections, key, this.openSections[key] === false ? true : false);
    },
    // Kaykhbi section ila kaع l-items dyalها mخبيين b'permission (l-DOM = source of truth)
    refreshNavSections() {
      if (!this.$el || !this.$el.querySelectorAll) return;
      this.$el.querySelectorAll('.js-nav-section').forEach(function (sec) {
        var body = sec.querySelector('.nav-group-body');
        var hasItem = body && body.querySelector('.link-menu');
        sec.style.display = hasItem ? '' : 'none';
      });
    },
    async fetchYoucanStatus() {
      if (!this.user || !['Seller', 'Partner'].includes(this.user.type)) return;
      if (this.user.accountType && !this.user.accountType.includes('seller')) return;
      try {
        const axios = (await import('../common/axios')).default;
        const { data } = await axios.get('youcan/status');
        this.youcanConnected = !!(data && data.content && data.content.connected);
      } catch (e) {
        this.youcanConnected = false;
      }
    },
    async getStatusUser() {
      if (this.user.status == "active") {
        this.status = true;
      } else {
        this.status = false;
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.user = res.content;
      else this.user = [];
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
    },
    hasApiAccess() {
      // For team members, check canViewApi permission
      if (this.user.parentSeller && this.user.teamPermissions) {
        return this.user.teamPermissions.canViewApi === true;
      }
      // For main sellers, partners and CEO
      return this.user.type === 'CEO' || this.user.type === 'Seller' || this.user.type === 'Partner';
    },
    getAccess(modelToCheck, accessToCheck) {
      // Check team permissions for team members (sellers with parentSeller)
      if (this.user.parentSeller && this.user.teamPermissions) {
        const teamPermMap = {
          'dashboard': { read: 'canViewDashboard' },
          'orders': { create: 'canCreateOrders', update: 'canEditOrders', delete: 'canDeleteOrders', read: 'canViewOrders' },
          'products': { create: 'canCreateProducts', update: 'canEditProducts', delete: 'canDeleteProducts', read: 'canViewProducts' },
          'expeditions': { create: 'canCreateExpeditions', update: 'canEditExpeditions', read: 'canViewExpeditions' },
          'shippings': { create: 'canManageShippings', update: 'canManageShippings', delete: 'canManageShippings', read: 'canViewShippings' },
          'payments': { read: 'canViewPayments' },
          'sourcings': { create: 'canCreateSourcings', update: 'canEditSourcings', read: 'canViewSourcings' },
          'sellerTeam': { create: 'canManageTeam', update: 'canManageTeam', delete: 'canManageTeam', read: 'canManageTeam' },
          'settings': { read: 'canViewSettings', update: 'canEditSettings' }
        };
        if (teamPermMap[modelToCheck] && teamPermMap[modelToCheck][accessToCheck]) {
          if (!this.user.teamPermissions[teamPermMap[modelToCheck][accessToCheck]]) {
            return false;
          }
        }
      }

      const permissions = this.user.role.permissions;
      for (let i in permissions) {
        let model = permissions[i]["model"];
        let access = permissions[i]["access"];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
    getPermission(name) {
      if (this.user) {
        // Check team permissions for team members (sellers with parentSeller)
        if (this.user.parentSeller && this.user.teamPermissions) {
          const teamPermMap = {
            'dashboard': 'canViewDashboard',
            'orders': 'canViewOrders',
            'products': 'canViewProducts',
            'expeditions': 'canViewExpeditions',
            'shippings': 'canViewShippings',
            'payments': 'canViewPayments',
            'sourcings': 'canViewSourcings',
            'sellerTeam': 'canManageTeam',
            'settings': 'canViewSettings'
          };
          if (teamPermMap[name]) {
            if (!this.user.teamPermissions[teamPermMap[name]]) {
              return false;
            }
          }
        }

        const permissions = this.user.role.permissions;
        for (let i in permissions) {
          let model = permissions[i]["model"];
          let access = permissions[i]["access"];

          if (model == name) {
            if (
              access.create ||
              access.read ||
              access.update ||
              access.delete
            ) {

              if ((this.user.type == 'CancelledOrder' || this.user.type == 'ToRemind') && name == 'shippings') return false
              else return true;
            } else {
              return false;
            }
          }
        }
      }
    },
  },
};
</script>

<style>
.img-cod {
  display: block !important;
}

.hide-menu {
  visibility: hidden;
  margin-left: -280px;
}

.dashbord img {
  width: 118px;
}

/* ===================== Modern sidebar polish (design only) ===================== */
/* Dégradé du fond sidebar — même famille que bg-green-600 (#01a653) */
/* height:auto + min-height:100% => la div grandit avec le contenu, donc le dégradé
   couvre TOUT (sinon en scrollant vers le bas l'ancien fond réapparaissait) */
#nav .h-full {
  height: auto !important;
  min-height: 100%;
  flex: 0 0 auto;   /* #nav = flex column => bla had flex-shrink:0 la div kat-n8ass l 100vh w l-gradient may8attiش l-contenu kaml */
  background-color: #01a653; /* fallback */
  background-image: linear-gradient(180deg, #04c063 0%, #01a653 45%, #017a3e 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

/* Nav items area — compact & aéré */
#nav .link-menu {
  padding: 8px 12px !important;
  margin: 2px 8px !important;
  border-radius: 9px;
  color: rgba(255,255,255,.92);
  transition: background-color .18s ease, color .18s ease, box-shadow .18s ease;
}
#nav .link-menu .material-icons { font-size: 20px; opacity: .95; }
#nav .link-menu .text-menu { font-size: 13.5px; font-weight: 500; letter-spacing: .1px; }
#nav .link-menu .img-storeino { height: 20px !important; }

/* Hover = translucent overlay (machi blanc kamel) */
.link:hover,
#nav .link-menu:hover {
  background-color: rgba(255,255,255,.14);
  color: #fff;
  border-radius: 9px;
}
#nav .link-menu:hover .text-menu { color: #fff; }

/* Active (exact) = pill blanc + vert */
#nav .router-link-exact-active.link-menu:not(.no-active) {
  background: #fff !important;
  color: #01a653 !important;
  box-shadow: 0 3px 8px rgba(0,0,0,.14);
  font-weight: 600;
}
#nav .router-link-exact-active.link-menu:not(.no-active) .text-menu { color: #01a653; font-weight: 600; }
#nav .router-link-exact-active.link-menu:not(.no-active) .material-icons { opacity: 1; }

/* ===== Sub-links (submenu) — CLAIREMENT distincts des menus principaux ===== */
#nav [class*="sub-sub-link"],
#nav .sub-link {
  margin: 1px 8px 1px 26px !important;
  padding: 6px 10px 6px 16px !important;
  border-left: 2px solid rgba(255,255,255,.30);
  border-radius: 0 8px 8px 0 !important;
}
#nav [class*="sub-sub-link"] .text-menu,
#nav .sub-link .text-menu {
  font-size: 12.5px !important;
  font-weight: 400;
  color: rgba(255,255,255,.80);
}
#nav [class*="sub-sub-link"] .material-icons,
#nav .sub-link .material-icons { font-size: 17px !important; opacity: .7; }
#nav [class*="sub-sub-link"] .img-storeino,
#nav .sub-link .img-storeino { height: 16px !important; opacity: .8; }
/* hover submenu */
#nav [class*="sub-sub-link"]:hover,
#nav .sub-link:hover {
  border-left-color: #fff;
  background: rgba(255,255,255,.12) !important;
}
#nav [class*="sub-sub-link"]:hover .text-menu,
#nav .sub-link:hover .text-menu { color: #fff; }
/* active submenu = pill blanc + accent vert à gauche */
#nav [class*="sub-sub-link"].router-link-exact-active,
#nav .sub-link.router-link-exact-active {
  border-left: 3px solid #01a653 !important;
  border-radius: 0 8px 8px 0 !important;
}

/* Custom scrollbar fin */
#nav { scrollbar-width: thin; scrollbar-color: rgba(255,255,255,.35) transparent; }
#nav::-webkit-scrollbar { width: 6px; }
#nav::-webkit-scrollbar-track { background: transparent; }
#nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,.28); border-radius: 8px; }
#nav::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,.45); }
/* ============================================================================== */

.youcan-wrap {
  position: relative;
}
.youcan-dot {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.3);
  pointer-events: none;
}

.img-link img:last-child {
  display: none;
}

.link:hover img:last-child,
.router-link-exact-active img:last-child {
  display: block;
}

.link:hover img:first-child,
.router-link-exact-active img:first-child {
  display: none;
}

/* ===================== Logo header ===================== */
.nav-header {
  background: linear-gradient(180deg, #ffffff 0%, #fbfefc 100%);
  padding: 16px 16px 14px;
  border-bottom: 1px solid rgba(0,0,0,.05);
  box-shadow: 0 3px 12px rgba(0,0,0,.06);
  position: relative;
  z-index: 6;
}
/* fin accent brand en bas du header */
.nav-header::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 3px;
  background: linear-gradient(90deg, #01a653 0%, #34d17f 55%, #a8e6c5 100%);
}
.nav-logo { padding: 2px 4px; border-radius: 8px; transition: background-color .2s ease; }
.nav-logo:hover { background: rgba(1,166,83,.06); }
.nav-logo img {
  width: 132px;
  max-width: 70%;
  height: auto;
  transition: transform .2s ease;
}
.nav-logo:hover img { transform: scale(1.02); }
.nav-close {
  color: #01a653;
  width: 36px; height: 36px;
  border-radius: 9px;
  justify-content: center;
  transition: background-color .18s ease;
}
.nav-close:hover { background: rgba(1,166,83,.10); }
.nav-close .material-icons { font-size: 24px; }

/* ===================== Sections (accordion) ===================== */
.nav-group { margin: 3px 6px 5px; }
.nav-group-head {
  width: 100%;
  display: flex; align-items: center; justify-content: space-between;
  padding: 7px 12px;
  background: transparent;
  border: none; outline: none; cursor: pointer;
  color: rgba(255,255,255,.72);
  text-transform: uppercase;
  letter-spacing: .6px;
  font-size: 11px; font-weight: 700;
  border-radius: 8px;
  transition: background-color .18s ease, color .18s ease;
}
.nav-group-head:hover { background: rgba(255,255,255,.10); color: #fff; }
.nav-group-arrow { font-size: 20px !important; opacity: .75; transition: transform .22s ease; }
.nav-group-arrow.is-open { transform: rotate(180deg); opacity: 1; }
.nav-group-body { padding: 1px 0 2px; }

/* ===================== Responsive ===================== */
@media (max-width: 768px) {
  #nav { width: 84vw; min-width: 84vw; max-width: 310px; }
  .nav-logo img { max-width: 55%; }
}

.vertical-navigation-mode-over {
  position: fixed !important;
  transform: translateZ(0);
  left: 0 !important;
  top: 0 !important;
  bottom: 0;
}

#nav {
  transition-duration: .4s;
  transition-timing-function: cubic-bezier(.25, .8, .25, 1);
  transition-property: visibility, margin-left, margin-right, transform, width, max-width, min-width;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #01a653;
  position: sticky;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  top: 0;
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  z-index: 10;
}
</style>
